import styled from "styled-components"

import Icon from "icons"
import NetworkAd from "components/network-ad"

export const NetworkAdUnit = styled(NetworkAd)`
  margin: 0;
`

export const CloseButton = styled.div`
  position: absolute;
  left: 0;
  width: 14.3rem;
  height: 3rem;
  border-bottom-right-radius: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.0833;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.primary};
  background-color: #f9f9f9;
  cursor: pointer;
`

export const ArrowIcon = styled(Icon)`
  margin-left: 0.7rem;
  transform: translateY(-0.1rem) rotate(-90deg) scale(0.8);
`
